import React from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import TextAtm from "../../atoms/TextAtm";
import { Arrow, Box, tooltipColor } from "./TooltipMolContent.styled";
function TooltipMolContent(_ref) {
  var boxProps = _ref.boxProps,
    arrowProps = _ref.arrowProps,
    placement = _ref.placement,
    children = _ref.children;
  var content = typeof children === "string" ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small1"
  }, children) : children;
  return /*#__PURE__*/React.createElement(Box, {
    ref: boxProps.ref,
    style: boxProps.style,
    "data-tooltip-placement": placement
  }, /*#__PURE__*/React.createElement(Arrow, {
    ref: arrowProps.ref,
    style: arrowProps.style
  }), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: tooltipColor
  }, content));
}
export default TooltipMolContent;